import PropTypes from 'prop-types';
import React from 'react';

import { clampNumber } from '../../../lib/NumberUtils';
import { createBEM } from '../../../lib/utils/css';
import {
  addWindowEventListener,
  clearTimeout,
  removeWindowEventListener,
  setTimeout,
} from '../../../tools/Globals';

import './Marquee.scss';

class Marquee extends React.Component {
  static propTypes = {
    useLightTheme: PropTypes.bool,

    /* children
     *   This component will animate an infinite horizontal scroll of its children
     *   if they exceed the width of the marquee. This can be any kind of component
     */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

    animationStyle: PropTypes.oneOf(['normal', 'startOnHover', 'stopOnHover']),
    /* animationStyle
     *   normal: marquee will animate if the content width exceeds the Marquee's width
     *   startOnHover: animate if contentWidth > marqueeWidth && user is hovering
     *   stopOnHover: animate if contentWidth > marqueeWidth && user is not hovering
     */
  };

  static defaultProps = {
    animationStyle: 'stopOnHover',
  };

  state = {
    animationSpeed: false, // falsy = no animation. number value = speed of marquee animation
  };

  componentDidMount() {
    addWindowEventListener('resize', this.handleResize);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.animationSpeed !== this.state.animationSpeed ||
      nextProps.children !== this.props.children ||
      nextProps.animationStyle !== this.props.animationStyle ||
      nextProps.useLightTheme !== this.props.useLightTheme
    );
  }

  componentDidUpdate() {
    this.measure();
  }

  componentWillUnmount() {
    removeWindowEventListener('resize', this.handleResize);
    if (this.measureTimeout && typeof this.measureTimeout !== 'undefined') {
      clearTimeout(this.measureTimeout);
    }
  }

  handleResize = () => {
    // custom debounce so that we can clear the interval when componentWillUnmount
    if (this.measureTimeout && typeof this.measureTimeout !== 'undefined') {
      clearTimeout(this.measureTimeout);
    }
    this.measureTimeout = setTimeout(this.measure, 100);
  };

  measure = () => {
    const me = this.componentRef;
    if (!me || !me.children || !me.children[0]) {
      this.setState({ animationSpeed: false });
      return;
    }

    const wrapperWidth = me.offsetWidth;
    // Prevent enabling speed when the wrapper hasn't been initialized with width yet
    if (wrapperWidth !== 0) {
      const contentWidth = me.children[0].offsetWidth;
      const speed =
        contentWidth > wrapperWidth ? clampNumber(5, (contentWidth / 500) * 8, 25) : false;
      this.setState({ animationSpeed: speed });
    }
  };

  setUpRef = component => {
    this.componentRef = component;
    this.measure();
  };

  render() {
    const classes = createBEM('Marquee', {
      [this.props.animationStyle]: !!this.props.animationStyle,
      lightTheme: this.props.useLightTheme,
    });
    if (!this.props.children || !this.state.animationSpeed) {
      return (
        <div className={classes} ref={this.setUpRef}>
          <div className='Marquee__wrapper__content'>{this.props.children}</div>
        </div>
      );
    }
    const animation = {
      animationDuration: this.state.animationSpeed + 's',
    };
    return (
      <div className={classes} ref={this.setUpRef}>
        <div className='Marquee__hiddenSizer'>{this.props.children}</div>
        <div className='Marquee__wrapper'>
          <div className='Marquee__wrapper__content--animating' style={animation}>
            <div className='Marquee__wrapper__content__child'>{this.props.children}</div>
            <div className='Marquee__wrapper__content__child'>{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Marquee;
